/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes,extraRequire}
 * tslint:disable
 */
var styles = ["#actions[_ngcontent-%COMP%]   button.btn-danger-outline[_ngcontent-%COMP%], #actions[_ngcontent-%COMP%]   button.btn-outline[_ngcontent-%COMP%]{float:right}#heading[_ngcontent-%COMP%]{margin-top:0}  #room-input clr-input-container.clr-form-control{margin:0;width:50%}.hover-item[_ngcontent-%COMP%]{margin-left:.25rem}"];
export { styles as styles };

